import { useCallback } from "react";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import useFetch from "@entrilia/shared/hooks/useFetch";
import { logError } from "@entrilia/shared/logging";
import adminApi from "../../../api/adminApi";
import EntitiesListPageContainer from "./EntitiesListPageContainer";

interface Props {
  objectType: string;
  objectDetailsPathPattern: string;
  objectsTitle?: string;
  showLogos?: boolean;
  allowCreate?: boolean;
}

const EntitiesListPage = ({ objectType, objectDetailsPathPattern, objectsTitle, showLogos, allowCreate }: Props) => {
  const getObjectDefinition = useCallback(() => adminApi.getObjectDefinition(objectType), [objectType]);

  const [objectDefinitionResp, objectDefinitionError] = useFetch(getObjectDefinition);

  const [dataImportOptions, dataImportOptionsError] = useFetch(adminApi.getDataImportOptions);

  const error = objectDefinitionError || dataImportOptionsError;
  if (error) {
    logError(error, "[EntitiesListPage]");
    return <DataLoadingFailed />;
  }

  if (objectDefinitionResp === undefined || dataImportOptions === undefined) {
    return <InlineLoader />;
  }

  return (
    <EntitiesListPageContainer
      objectClassDefinition={objectDefinitionResp.objectClassDefinition}
      objectPermissions={objectDefinitionResp.objectPermissions}
      dataImportOptions={dataImportOptions}
      objectDetailsPathPattern={objectDetailsPathPattern}
      objectsTitle={objectsTitle}
      showLogos={showLogos}
      allowCreate={allowCreate}
    />
  );
};

export default EntitiesListPage;
